import React from "react";

function Footer() {
  return (
    <footer style={styles.footer}>
      <h2>Unblemished Advocacy</h2>
      
      <p>Advocating for corruption free lives and academics</p>


      <p style={styles.copy}>
        © {new Date().getFullYear()} Unblemished Advocacy. All rights reserved.
      </p>
    </footer>
  );
}

const styles = {
  footer: {
    background: "#111",
    color: "white",
    textAlign: "center",
    padding: "40px 20px"
  },
  links: {
    display: "flex",
    justifyContent: "center",
    gap: "20px",
    margin: "20px 0"
  },
  copy: {
    fontSize: "14px",
    color: "#aaa"
  }
};

export default Footer;